<template>
    <div>
        <md-cell-item :title="ct.type" :brief="ct.account" arrow>
            <iconimg :name="ct.type" slot="left"></iconimg>
            <div slot="default">
                <div class="upi-text">{{ ct.pnname }}</div>
                <div class="upi-text">{{ ct.upi }}</div>
                <div>
                    Link Status:
                    <pointtext class="ct-status" type="fail" text="Disabled" v-if="get_ct_status() === 'Disabled'">
                    </pointtext>
                    <pointtext class="ct-status" type="success" text="Active" v-if="get_ct_status() === 'Active'">
                    </pointtext>
                    <pointtext class="ct-status" type="notline" text="UnLink" v-if="get_ct_status() === 'UnLink'">
                    </pointtext>
                    <pointtext class="ct-status" type="notline" text="Waiting Kyc" v-if="get_ct_status() === 'Waiting'">
                    </pointtext>
                    <pointtext class="ct-status" type="notline" text="AuthUPI" v-if="get_ct_status() === 'AuthUPI'">
                    </pointtext>
                </div>
                <div class="kyc-remark">
                    Remark: {{ get_ctremark(ct.remark) }}
                </div>
            </div>
            <span slot="right" @click="$_showActionSheet">Operating</span>
        </md-cell-item>
        <a ref="myLink" :href="linkurl"></a>
        <md-captcha
            ref="captcha"
            v-model="show"
            :count="120"
            count-active-text="{$1} ReSend"
            count-normal-text="ReSend"
            :title="title"
            :maxlength="-1"
            :system="system"
            :mask="mask"
            :appendTo="appendTo"
            @submit="captcha_submit"
            @show="onShow"
            @hide="onHide"
            @send="onSend"
        >
            {{content}}
        </md-captcha>
    </div>
</template>

<script>
import iconimg from '@/components/iconimg'
import pointtext from '@/components/pointtext'
import {Popup, PopupTitleBar, ActionSheet, Dialog} from 'mand-mobile'
import { editcollectiontool, getcollectiontool, deletecollectiontool, send_otp, otp_login, service_login } from '@/request/api'

export default {
    name: 'kycpartneritem',
    props: {
        ct: {
            type: Object,
            default: {}
        }
    },
    components: {
        iconimg,
        pointtext,
        [Popup.name]: Popup,
        [PopupTitleBar.name]: PopupTitleBar,
    },
    data() {
        return {
            linkurl: "",
            show: false,
            appendTo: document.body,
            title: 'Enter OTP',
            content: 'OTP has been sent',
            mask: false,
            system: true,
            otpinterval: "",
            otp_send_times: 0
        }
    },
    created() {},

    methods: {
        get_ctremark(remark) {
            let outputString = remark;
            if(remark) {
                outputString = remark.replace(/[^\x00-\xff]/g, "?");
            } else {
                outputString = 'NA'
            }
            return outputString
        },
        refresh_ct() {
            getcollectiontool({id: this.ct.id}).then(res=>{
                if(res.code === 200) {
                    this.ct = res.data
                } else {
                    this.$toast.failed(res.errmsg)
                }
            })
        },
        get_ct_status() {
            if (this.ct.status === 'unavailable') {
                return "Disabled"
            }
            if (this.ct.status === 'available' && (this.ct.state === 'receiving' || this.ct.state === 'idle')) {
                return 'Active'
            }
            if (this.ct.status === 'available' && (this.ct.state === 'disabled' || this.ct.state === 'not_online' || this.ct.state === 'timeout')) {
                return 'UnLink'
            }
            if (this.ct.status === 'available' && (this.ct.state === 'waiting_online')) {
                return 'Waiting'
            }
            if(this.ct.status === 'available' && (this.ct.state === 'waiting_authupi')) {
                return 'Auth UPI'
            }
            if (this.ct.status === 'pause') {
                return 'UnLink'
            }
            if(this.ct.status == 'waitauth') {
                return 'AuthUPI'
            }
        },
        get_operate_options(){
            let ct_status = this.get_ct_status();
            let options = [
                {
                    label: 'Link Kyc Partner',
                    value: 'link',
                },
                {
                    label: 'Disconnect',
                    value: 'disconnect',
                },
                {
                    label: 'Edit',
                    value: 'edit',
                },
                {
                    label: 'Delete',
                    value: 'delete'
                },
            ];
            if(ct_status === 'Disabled') {
                options = [
                    {
                        label: 'Edit',
                        value: 'edit'
                    },
                    {
                        label: 'Delete',
                        value: 'delete'
                    },
                ];
            }

            if(ct_status === 'UnLink') {
                options = [
                    {
                        label: 'Link Kyc Partner',
                        value: 'link',
                    },
                    {
                        label: 'Edit',
                        value: 'edit',
                    }
                ];
            }

            if(ct_status === 'Active') {
                options = [
                    {
                        label: 'Disconnect',
                        value: 'disconnect'
                    }
                ];
            }
            if(ct_status === 'Waiting') {
                options = [
                    {
                        label: 'Waiting Kyc',
                        value: 'waiting_kyc'
                    }
                ];
            }
            if(ct_status === 'AuthUPI') {
                options = [
                    {
                        label: 'Auth UPI',
                        value: 'auth_upi'
                    },
                    {
                        label: 'Edit',
                        value: 'edit',
                    }
                ]
            }
            return options
        },
        $_showActionSheet() {
            let options = this.get_operate_options();
            ActionSheet.create({
                value: true,
                title: 'Operate the linked Kyc Partner',
                options: options,
                defaultIndex: 0,
                cancelText: 'Cancel',
                onCancel: this.$_cancel,
                onSelected: this.$_selected,
            })
        },
        $_selected(item) {
            if(item.value === 'link') {
                this.link();
            } else if (item.value === 'disconnect') {
                this.disconnect()
            } else if (item.value === 'edit') {
                this.$router.push('/editkycpartner/' + this.ct.id)
            } else if (item.value === 'delete') {
                deletecollectiontool({id: this.ct.id}).then(res=>{
                    if(res.code === 200) {
                        this.$toast.succeed('delete successfully');
                        this.$emit('refreshkyclist');
                    } else {
                        this.$toast.failed(res.errmsg);
                        this.refresh_ct();
                    }
                })
            } else if (item.value === 'auth_upi') {
                this.show_auth();
            }
        },
        $_cancel() {
            console.log('action-sheet cancel')
        },
        getlink() {
            let account = this.ct;
            if (account.type === "paytm") {
                return "xaml:{url:paytm,id:" + account.id + ",upi:" + account.upi + ",account:" + account.account + "}";
            } else if (account.type === "freecharge") {
                return "xaml:{url:freecharge,id:" + account.id + ",upi:" + account.upi + ",account:" + account.account + "}";
            } else if (account.type === "mobikwik") {
                return "xaml:{url:mobikwik,id:" + account.id + ",upi:" + account.upi + ",account:" + account.account + "}";
            } else if (account.type === "phonepe") {
                return "javascript:;"
            } else {
                return "";
            }
        },
        link() {
            let ct = this.ct;
            this.$toast.loading("waiting for link");
            editcollectiontool({
                id: ct.id,
                status: 'available'
            }).then(res=>{
                this.$toast.hide();
                if(res.code === 200) {
                    this.$toast.succeed("link successful");
                    this.refresh_ct();
                } else {
                    let otp = ["phonepe"];
                    let service_login = ["bharatpe"];
                    if(otp.includes(this.ct.type)) {
                        this.show_captcha();
                    } else if(service_login.includes(this.ct.type)){
                        this.service_login();
                    } else {
                        this.linkurl = this.getlink();
                        let that = this;
                        setTimeout(()=>{
                            that.$refs.myLink.click();
                            that.$toast.hide();
                        }, 1500);
                    }
                }
            })
        },
        service_login() {
            service_login({
                ct_id: this.ct.id
            }).then(res=>{
                if(res.code === 200) {
                    this.$toast.succeed("link successful, pls wait");
                    this.refresh_ct();
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })
        },
        show_captcha() {
            this.$toast.loading("OTP send...", 0, true, '', true);
            let that = this;
            that.otp_send_times = 0;
            this.otpinterval = setInterval(() => {
                send_otp({
                    ct_id: this.ct.id,
                    phone: this.ct.account
                }).then(res=>{
                    if(res.code === 200) {
                        that.first = true;
                        that.show = true;
                        clearInterval(that.otpinterval);
                        that.$toast.hide();
                    } else {
                        that.otp_send_times = that.otp_send_times + 1;
                    }
                })
                if(that.otp_send_times > 5) {
                    that.$toast.hide();
                    clearInterval(that.otpinterval);
                    that.$toast.failed("otp send fail, pls try agent", 5000, true, '', true);
                };
            }, 5000);
        },
        captcha_submit(code) {
            let that = this;
            otp_login({
                ct_id: this.ct.id,
                otp: code
            }).then(res=>{
                if(res.code === 200) {
                    that.show = false;
                    Dialog.succeed({
                        title: 'Success',
                        content: 'Please wait patiently for 2~3 minutes, kyc partner will verify the authorization to TT',
                        cancelText: 'Cancel',
                        confirmText: 'Ok',
                        onConfirm: () => {
                            
                        },
                    })
                } else {
                    this.$refs.captcha.setError(res.errmsg);
                }
            })
        },
        disconnect() {
            Dialog.confirm({
                title: 'Confirm',
                content: 'Confirm whether to unlink',
                confirmText: 'Confirm',
                cancelText: 'Cancel',
                onConfirm: () => {
                    editcollectiontool({
                        id: this.ct.id,
                        status: "pause"
                    }).then(res=>{
                        if(res.code === 200) {
                            this.$toast.succeed("Successfully unlinked");
                            this.refresh_ct();
                        } else {
                            this.$toast.failed(res.errmsg);
                            this.refresh_ct();
                        }
                    })
                },
            })
        },
        onSend() {
            if(this.first) {
                this.first = false;
                return;
            }
            send_otp({
                ct_id: this.ct.id,
                phone: this.ct.account
            }).then(res=>{
                if(res.code === 200) {
                    
                } else {
                    this.$refs.captcha.setError(res.errmsg);
                    this.$refs.captcha.resetcount();
                }
            })
        },
        onShow() {},
        onHide() {},

        show_auth() {
            this.$router.push('/authupi/' + this.ct.id);
        }
    },
        
}

</script>
<style scoped>
.upi-text {
    max-width: 2rem;
}
.kyc-remark {
    color: #858b9c;
    font-size: 0.27rem;
}
.ct-status {
    display: inline;
}</style>



// WEBPACK FOOTER //
// src/views/my/kycpartneritem.vue